import { Injectable } from '@angular/core';
import { CanActivate, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { UserStatus } from '@shared/models';
import { DialogService } from '@migo-apps/dialogs';

@Injectable({
  providedIn: 'root',
})
export class FirstLoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private authSvc: AuthenticationService,
    private dialog: DialogService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authSvc.getUser$().pipe(
      map((user) => {
        if (user) {
          if (user.status === UserStatus.CREATED) {
            this.dialog.openSnackbar('Primero debes activar tu cuenta');
            return this.router.createUrlTree(['auth', 'activate-account']);
          } else {
            return true;
          }
        }

        return this.router.createUrlTree(['/']);
      })
    );
  }
}
